module.exports = __webpack_public_path__ + "static/img/automation.69bc09ec.png";